import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle, Spinner
} from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { VsiSpanText } from "../styled/App.styled";

function VsiDropdown({
    isOpen,
    toggle,
    disabled,
    direction,
    inNavbar,
    onMouseLeave,
    onMouseEnter,
    caret,
    end,
    toggleStyle,
    toggleVal,
    dark,
    className,
    children,
    toggleClassName,
    toggleValPrefix,
    tag,
    dropdownMenuStyle,
    loading,
}) {
    return (
        <Dropdown
            className={className}
            active={false}
            inNavbar={inNavbar}
            isOpen={isOpen}
            toggle={toggle}
            direction={direction}
            onMouseLeave={onMouseLeave}
            onMouseEnter={onMouseEnter}>
            <DropdownToggle
                tag={tag}
                className={toggleClassName}
                disabled={disabled}
                caret={caret}
                style={toggleStyle}>
                {toggleValPrefix}
                {toggleVal}
                {loading ? <VsiSpanText>
                  Loading...
                    <Spinner size={"sm"} color={"secondary"} className={"ms-1"}/>
                </VsiSpanText>: null}
            </DropdownToggle>
            <DropdownMenu end={end} dark={dark} style={dropdownMenuStyle}>
                {children}
            </DropdownMenu>
        </Dropdown>
    )
}

export default withErrorBoundary(VsiDropdown, GeneralErrorBoundary);
